import request from "../utils/request";

export const get = (id) => request.get(`/api/system_setting/${id}`);
export const list = (data) => request.get("/api/system_setting", data);
export const create = (data) => request.post("/api/system_setting", data);
export const update = (id, data) => request.put(`/api/system_setting/${id}`, data);
